import Link from './TabLink';
import Container from './TabContainer';

const Tabs = {
  Link,
  Container,
};

export default Tabs;
